import router from '@/vue-instance/router';
import api from '@/services/gateway/api';

const baseUrl = 'camp/sales/positions';
const indexRoute = { name: 'camp.sales-positions.index' };

const normalize = (payload) => {
  return { ...payload, is_active: payload.is_active ? 1 : 0 };
};

const isValidationError = (error) => Boolean(
  error && error.response && error.response.status === 422
);

// Бэкенд отдаёт ошибки 422 как массив { field: 'message' }; AppBackendErrorBlock
// ждёт Laravel-формат { field: ['message', ...] }. Перекладываем формат и пишем
// в общий validation store, чтобы инлайн-ошибки появлялись под полями.
const remapValidationErrors = (dispatch, error) => {
  if (!isValidationError(error)) return;
  const raw = (error.response.data && error.response.data.errors) || [];
  if (!Array.isArray(raw)) return;

  const mapped = {};
  raw.forEach((entry) => {
    if (!entry || typeof entry !== 'object') return;
    Object.keys(entry).forEach((key) => {
      const value = entry[key];
      if (!mapped[key]) mapped[key] = [];
      if (Array.isArray(value)) {
        mapped[key].push(...value);
      } else {
        mapped[key].push(value);
      }
    });
  });

  dispatch('validation/setErrors', mapped, { root: true });
};

const state = {
  list: []
};

const getters = {
  getList: (state) => state.list,
  getById: (state) => (id) => state.list.find((item) => String(item.id) === String(id))
};

const mutations = {
  setList (state, data) {
    state.list = data;
  },
  replaceItem (state, data) {
    const index = state.list.findIndex((item) => item.id === data.id);
    if (index !== -1) {
      state.list.splice(index, 1, data);
    }
  }
};

const actions = {
  getList ({ commit }, payload) {
    return api.get(baseUrl, { params: payload })
      .then((response) => {
        commit('setList', response.data.data);
        return response.data.data;
      });
  },
  addItem ({ dispatch }, payload) {
    return api.post(baseUrl, normalize(payload))
      .then((response) => {
        router.push(indexRoute);
        return response.data.data;
      })
      .catch((error) => {
        remapValidationErrors(dispatch, error);
        throw error;
      });
  },
  editItem ({ dispatch }, payload) {
    const data = { ...normalize(payload), _method: 'PUT' };
    return api.post(`${baseUrl}/${payload.id}`, data)
      .then((response) => {
        router.push(indexRoute);
        return response.data.data;
      })
      .catch((error) => {
        remapValidationErrors(dispatch, error);
        throw error;
      });
  },
  toggleVisibility ({ commit }, { id, is_active }) {
    return api.post(`${baseUrl}/${id}/visibility`, { _method: 'PATCH', is_active: is_active ? 1 : 0 })
      .then((response) => {
        commit('replaceItem', response.data.data);
        return response.data.data;
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
